import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import LeadingZeroesTable from "./LeadingZeroesTable";
import LeadingZeroesDeleteModal from "./LeadingZeroesDeleteModal";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const LeadingZeroesPage = () => {
	// ************************************************ */
	// LOCAL STORAGE AND VARIABLES ******************** */
	const { permissions } = useSelector((state: RootState) => state.user);
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************* */
	// USE EFFECT ************************************** */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{validatePermission("leading-zeroes-view", permissions) ? (
				<div className={`layout__contentPage__${theme}`}>
					<LeadingZeroesTable />
					<LeadingZeroesDeleteModal />
				</div>
			) : (
				<UnauthorizedPage />
			)}
		</div>
	);
};

export default LeadingZeroesPage;
